import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { DealsWizardModel, DealServiceItemModel } from '../../../../_models/_index';
import { GeneralService } from '../../../../services/_index';
import { DealStepEnum, ViewModeEnum, AlertDialogTypeEnum } from '../../../../_enums/_index';
import { DealServiceItemDialogComponent } from '../deal-service-item-dialog/deal-service-item-dialog.component';


@Component({
  selector: 'app-deal-service-items-grid',
  templateUrl: './deal-service-items-grid.component.html',
  styleUrls: ['./deal-service-items-grid.component.css']
})
export class DealServiceItemsGridComponent implements OnInit {

    @Input()
    dealsWizard: DealsWizardModel;
    cols: any[];

    constructor(private dialog: MatDialog,
        private generalService: GeneralService
    ) {

    }

    ngOnInit() {
        this.cols = [

            { field: 'id', header: '', formatCell: "buttons", width: '20%' },
            { field: 'description', header: 'פרטי שירות', formatCell: "none", width: '40%' },
            { field: 'price', header: 'מחיר', formatCell: "none", width: '20%' },
            { field: 'remark', header: 'הערה', formatCell: "none", width: '35%' },
            { field: 'isBold', header: 'מודגש?', formatCell: "checkbox", width: '14%' },
            { field: 'id', header: '', formatCell: "reorder", width: '12%' }
        ];
    }

    openAddServiceItemDialog() {
        let dialogRef = this.dialog.open(DealServiceItemDialogComponent);
        dialogRef.disableClose = true;
        dialogRef.componentInstance.dialogHeader = 'הוספת פריט שירות';
        dialogRef.componentInstance.viewMode = ViewModeEnum.Add;
        dialogRef.afterClosed().subscribe((result: DealServiceItemModel) => {
            if (result) {
                let copy = Object.assign([], this.dealsWizard.dealServiceItems);
                result.id = this.getMaxServiceItemID();
                copy.push(result);
                this.dealsWizard.dealServiceItems = copy;
                this.generalService.setIsDirty('true');
            }
        });
    }

    getMaxServiceItemID() {
        let id = 0;
        this.dealsWizard.dealServiceItems.forEach(dsi => {
            if (dsi.id > id)
                id = dsi.id;
        });
        return id + 1;
    }

    openEditServiceItemDialog(serviceItem: DealServiceItemModel) {
        let dialogRef = this.dialog.open(DealServiceItemDialogComponent);
        dialogRef.disableClose = true;
        dialogRef.componentInstance.dialogHeader = 'עריכת פריט שירות';
        dialogRef.componentInstance.viewMode = ViewModeEnum.Edit;
        let serviceItem2edit: DealServiceItemModel = new DealServiceItemModel();
        serviceItem2edit = Object.assign({}, <DealServiceItemModel>serviceItem);
        dialogRef.componentInstance.dealServiceItem = serviceItem2edit;
        dialogRef.afterClosed().subscribe((result: DealServiceItemModel) => {
            if (result) {
                let copy = Object.assign([], this.dealsWizard.dealServiceItems);
                copy.splice(this.dealsWizard.dealServiceItems.findIndex(c => c.id == result.id), 1, result);
                this.dealsWizard.dealServiceItems = copy;
                this.generalService.setIsDirty('true');
            }
        });
    }

    deleteDealTerm(serviceItem: DealServiceItemModel) {
        this.generalService.showConfirmDialog("האם למחוק את פריט השירות '" + serviceItem.description + "'?").then(res => {
            if (res) {
                let copy = Object.assign([], this.dealsWizard.dealServiceItems);
                copy.splice(this.dealsWizard.dealServiceItems.findIndex(c => c.id == serviceItem.id), 1);
                this.dealsWizard.dealServiceItems = copy;
                this.generalService.setIsDirty('true');
            }
        });

    }

}



// WEBPACK FOOTER //
// ./src/app/components/deal-wizard/deal-package/deal-service-items-grid/deal-service-items-grid.component.ts